export const DEFAULT_PROCESSING_COUNTER = 1
// может быть пригодится, если придется менять количество аплодов у не зареганных пользователей
export const FIRST_PROCESSING_COUNTER = 1
